<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="endurasureProForm">
        <div class="my-section-box__headline">
        {{ 'common.value_calculator_upcharge_title' | cxTranslate }}</div>
        <div class="my-section-box endurasurePro" id="endurasurePro">
          <div class="my-section-box-inner fleet-info-block">
            <div class="row col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-10 ">
                <label class="form-label" for="estUpchargeForEndTractor">{{
                'common.value_calculator_estUpchargeForEndTractor' | cxTranslate }}</label>
                <div class="col-12  row">
                  <div class="col-8 col-sm-6 pr-0 pl-0">
                    <input type="number" formControlName="estUpchargeForEndTractor" />
                    @if (form.estUpchargeForEndTractor.invalid && (form.estUpchargeForEndTractor.dirty || form.estUpchargeForEndTractor.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.value_calculator_estUpchargeForEndTractor_errorMsg'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EndaTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="endasureService.openTootlip(
                             'common.value_calculator_estUpchargeForEndTractor',
                              'common.value_calculator_enduraSure_perTractor_desc')" class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="endasure-pro">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
            </div>
            <div class="row col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-10">
                <label class="form-label" for="estUpchargeForEndTrailer">
                {{ 'common.value_calculator_estUpchargeForEndTrailer' | cxTranslate }}</label>
                <div class="col-12  row">
                  <div class="col-8  col-sm-6 pr-0 pl-0">
                    <input type="number" formControlName="estUpchargeForEndTrailer" />
                    @if (form.estUpchargeForEndTrailer.invalid && (form.estUpchargeForEndTrailer.dirty || form.estUpchargeForEndTrailer.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.value_calculator_estUpchargeForEndTrailer_errorMsg'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-sm-5 EndaTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="endasureService.openTootlip( 
                            'common.value_calculator_estUpchargeForEndTrailer', 
                            'common.value_calculator_enduraSure_perTrailer_desc')" class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="endasure-pro">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
            </div>
            <div class="airdisk-button-block">
              <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn"
                (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow" alt="">
              {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
              <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn"
                (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                <img src="/icons/link-right-white.svg" class="right-arrow" alt=""></button>
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  </div>